import { render } from "./FeesComponent.vue?vue&type=template&id=2a182bfa"
import script from "./FeesComponent.vue?vue&type=script&lang=js"
export * from "./FeesComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kreigdurham/Documents/Git/af3-shortcodes/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__